import * as React from "react";
import { stylesheetSingleton } from "./auth-service-tools1290.js";

var styleHookSingleton = function () {
  var sheet = stylesheetSingleton();
  return function (styles, isDynamic) {
    React.useEffect(function () {
      sheet.add(styles);
      return function () {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};

export { styleHookSingleton };